import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LoginPage from './components/LoginPage';
import LoginRedirect from './components/LoginRedirect';
import JobApplicationsList from './components/JobApplicationsList';
import JobApplicationDetail from './components/JobApplicationDetail';
import Header from './components/Header';
import './App.css';

interface AppProps {
  apiUrl: string;
  audience: string;
}

const App: React.FC<AppProps> = ({ apiUrl, audience }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="app">
      <Header />
      <div className="container">
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? 
                <Navigate to="/applications" /> : 
                <LoginPage />
            } 
          />
          <Route 
            path="/login" 
            element={<LoginRedirect />} 
          />
          <Route 
            path="/applications" 
            element={
              isAuthenticated ? 
                <JobApplicationsList apiUrl={apiUrl} audience={audience} /> : 
                <Navigate to="/" />
            } 
          />
          <Route 
            path="/applications/:id" 
            element={
              isAuthenticated ? 
                <JobApplicationDetail apiUrl={apiUrl} audience={audience} /> : 
                <Navigate to="/" />
            } 
          />
        </Routes>
      </div>
    </div>
  );
};

export default App;
